import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { chiudiSessione } from "../auth/sessione";

export default function TokenExpiredModal() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleTokenExpired = () => setOpen(true);
    window.addEventListener("token-expired", handleTokenExpired);
    return () => window.removeEventListener("token-expired", handleTokenExpired);
  }, []);

  const handleLogin = async () => {
    setOpen(false);
    await chiudiSessione();
    navigate("/login");
  };

  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Sessione scaduta</DialogTitle>
      <DialogContent>
        <DialogContentText>
          La tua sessione è scaduta. Effettua nuovamente il login per
          continuare.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleLogin} variant="contained" autoFocus>
          Vai al login
        </Button>
      </DialogActions>
    </Dialog>
  );
}
